/* eslint-disable no-unused-vars */
export enum ServicesEnum {
  ALL = "All",
  WEB_DEVELOPMENT = "Web Development",
  PRODUCT_DEVELOPMENT = "Product Development",
  UI_UX_DEVELOPMENT = "UI/UX Development",
}
